import React, { Ref, HTMLAttributes, forwardRef } from 'react';
import { classNames } from 'primereact/utils';

import './List.scss';

export type ArrowListProps = HTMLAttributes<HTMLUListElement> & {
	additionalElementMargin?: boolean;
};

export const ArrowList = forwardRef(
	(
		{ children, className, additionalElementMargin = false, ...restProps }: ArrowListProps,
		ref: Ref<HTMLUListElement>
	) => {
		return (
			<ul
				ref={ref}
				className={classNames('list arrow-list', { 'arrow-list-am': additionalElementMargin }, className)}
				{...restProps}
			>
				{children}
			</ul>
		);
	}
);
